import {
  Checkbox,
  FormControlLabel,
  type RadioProps,
  Typography,
  type TypographyProps,
  FormGroup as MuiFormGroup,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'

export const Title = styled((props) => (
  <Typography variant="subtitle1" color="secondary" {...props} />
))<TypographyProps>(() => ({}))

interface CheckboxControlProps extends RadioProps {
  error: boolean
}
export const CheckboxControl = styled((props) => <Checkbox {...props} />, {
  shouldForwardProp: youShallNotPass(['error']),
})<CheckboxControlProps>(({ error, theme }) => ({
  ...(error && { color: theme.palette.error.main }),
}))

export const Label = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  gap: theme.spacing(1),
  alignItems: 'center',
  border: `1px solid ${theme.tokens.ThemeColorCommonOutline}`,
  '&:has(.Mui-checked)': {
    backgroundColor: theme.tokens.ThemeColorCommonBackground,
  },
  padding: theme.spacing(1.5, 2.5),
  '&:not(:last-of-type)': {
    borderBottom: 'none',
  },
  '&:last-of-type': {
    borderRadius: theme.spacing(0, 0, 1, 1),
  },
  '&:first-of-type': {
    borderRadius: theme.spacing(1, 1, 0, 0),
  },
  '&:last-of-type:first-of-type': {
    borderRadius: theme.spacing(1),
  },
}))

export const FormGroup = styled(MuiFormGroup)(() => ({}))
